import React from "react";
import { FaBusAlt, FaChild, FaFileInvoiceDollar } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const Tiles = ({ allowedServices }) => {
  const navigate = useNavigate();
  console.log("Allowed Services", allowedServices);
  const services = [
    {
      key: "ChildPause",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="3em"
          height="3em"
          viewBox="0 0 48 48"
        >
          <path
            fill="#e6ffe6"
            d="M5 38V14h38v24c0 2.2-1.8 4-4 4H9c-2.2 0-4-1.8-4-4"
          />
          <path
            fill="green"
            d="M43 10v6H5v-6c0-2.2 1.8-4 4-4h30c2.2 0 4 1.8 4 4"
          />
          <g fill="green">
            <circle cx="33" cy="10" r="3" />
            <circle cx="15" cy="10" r="3" />
          </g>
          <path
            fill="#bdbdbd"
            d="M33 3c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2s2-.9 2-2V5c0-1.1-.9-2-2-2M15 3c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2s2-.9 2-2V5c0-1.1-.9-2-2-2"
          />
          <path
            fill="green"
            d="M22.2 35.3c0-.2 0-.5.1-.7s.2-.4.4-.5s.3-.3.5-.3c.2-.1.5-.1.7-.1s.5 0 .7.1l.6.3c.2.1.3.3.4.5s.1.4.1.7c0 .2 0 .5-.1.7s-.2.4-.4.5s-.3.3-.6.3s-.3.2-.6.2s-.5 0-.7-.1s-.4-.2-.5-.3c-.2-.1-.3-.3-.4-.5c-.1-.3-.2-.5-.2-.8m3.1-4.3h-2.6l-.4-11h3.3z"
          />
        </svg>
      ),
      title: "Take A Break",
      subtitle: "Pause Service",
    },
    {
      key: "Center Shift",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="3em"
          height="3em"
          viewBox="0 0 14 14"
        >
          <path
            fill="orange"
            d="M6.646.854L1.354 6.146A.5.5 0 0 0 1.707 7H3.5v6a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V7h1.793a.5.5 0 0 0 .353-.854L7.354.854a.5.5 0 0 0-.708 0"
          />
        </svg>
      ),
      title: "Shift Center",
      subtitle: "Request A Transfer",
    },
    {
      key: "Program Change",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="3em"
          height="3em"
          viewBox="0 0 48 48"
        >
          <g
            fill="none"
            stroke="green"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="4"
          >
            <path d="M18 31h20V5" />
            <path d="M30 21H10v22m34-32l-6-6l-6 6" />
            <path d="m16 37l-6 6l-6-6" />
          </g>
        </svg>
      ),
      title: "Change Program",
      subtitle: "Request Change Program",
    },
    {
      key: "Finance",
      alwaysShow: true,
      icon: <FaFileInvoiceDollar className="text-4xl text-[#ffa500]" />,
      title: "Finance",
      subtitle: "Pay Invoices, Fee Certificate & Account Statement",
    },
    {
      key: "Transport",
      icon: <FaBusAlt className="text-4xl text-[#008001]" />,
      title: "Transport",
      subtitle: "Start or Stop Transfer Service",
    },
    {
      key: "ChildWithdraw",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="3em"
          height="3em"
          viewBox="0 0 256 256"
        >
          <path
            fill="orange"
            d="M128 56h-16V16a8 8 0 0 1 16 0Zm64 67.62V72a16 16 0 0 0-16-16h-48v60.69l18.34-18.35a8 8 0 0 1 11.32 11.32l-32 32a8 8 0 0 1-11.32 0l-32-32a8 8 0 0 1 11.32-11.32L112 116.69V56H64a16 16 0 0 0-16 16v128a8 8 0 0 0 8 8h74.7c.32.67.67 1.34 1.05 2l.24.38l22.26 34a8 8 0 0 0 13.39-8.76l-22.13-33.79A12 12 0 0 1 166.4 190c.07.13.15.26.23.38l10.68 16.31a8 8 0 0 0 14.69-4.38V144a74.84 74.84 0 0 1 24 54.69V240a8 8 0 0 0 16 0v-41.35a90.89 90.89 0 0 0-40-75.03"
          />
        </svg>
      ),
      title: "Withdraw Child",
      subtitle: "Share Date, Reason, and Feedback",
    },
    {
      key: "Extended Daycare",
      icon: <FaChild className="text-4xl text-[#008001]"></FaChild>,
      title: "Extended Daycare",
      subtitle: "Extend Daycare",
    },
  ];

  const allowedKeys = allowedServices.map((service) => service.key);

  const handleClick = (serviceKey) => {
    console.log("serviceKey", serviceKey);
    console.log("AllowedServices", allowedServices);
    const service = allowedServices.find((s) => s.key === serviceKey);
    if (service && service.pendingRequest) {
      navigate("/PastRequestTab");
    } else {
      navigate(`/${service.path}`);
    }
  };

  return (
    <div>
      {services
        .filter(
          (service) =>
            service.alwaysShow || allowedKeys.indexOf(service.key) > -1
        )
        .map((service) => (
          <div key={service.key} onClick={() => handleClick(service.key)}>
            <div className="grid grid-cols-12 gap-1 col-span-12 h-18 w-full p-2 cursor-pointer">
              <div className="col-span-2 flex items-center justify-center">
                {service.icon}
              </div>
              <div className="col-span-10 flex flex-col justify-center">
                <h3 className="text-base font-semibold xl:text-xl">
                  {service.title}
                </h3>
                <h4 className="text-xs xl:text-sm">{service.subtitle}</h4>
              </div>
            </div>
            <hr className="mt-2 mx-3 bg-dark text-dark" />
          </div>
        ))}
    </div>
  );
};

export default Tiles;
